const handleBrandIdsParameter = () => {
  if (!process.env.GATSBY_BRAND_ID) return { param: 'brandId', value: '' }

  const brandIds = process.env.GATSBY_BRAND_ID
  const brandIdsList = brandIds.split(',')

  return {
    param: brandIdsList.length > 1 ? 'brandIds' : 'brandId',
    value: brandIdsList.length > 1 ? brandIds : brandIdsList[0],
  }
}

const getNavLink = ({
  schedulingLinkNav,
  navName,
  context,
  productIds,
  utmSource,
  utmCampaign,
}) => {
  const { param: brandIdParam, value: brandIdValue } = handleBrandIdsParameter()

  const params = new URLSearchParams({
    laboratorio: navName,
    redirectTo: `/${context}/paciente`,
    utm_source: utmSource,
    utm_medium: 'site',
    utm_campaign: utmCampaign,
  })

  if (productIds) {
    params.append('productIds', productIds)
  }

  params.append(brandIdParam, brandIdValue)

  return `${schedulingLinkNav}/entrar?${params.toString()}`
}

module.exports = { getNavLink, handleBrandIdsParameter }
